import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAdminApi, errMsg, money } from "@/lib/site";
import { AdminTitle } from "./AdminMessages";

const badge = (s) => ({ paid: "bg-emerald-50 text-emerald-700", pending: "bg-amber-50 text-amber-700" }[s] || "bg-slate-100 text-slate-600");

export default function AdminPayments() {
  const call = useAdminApi();
  const [list, setList] = useState(null);
  useEffect(() => { call("get", "/admin/payments").then(setList).catch((e) => toast.error(errMsg(e))); }, [call]);
  const paid = (list || []).filter((p) => p.payment_status === "paid");
  return (
    <div data-testid="admin-payments">
      <AdminTitle sub="Card (Stripe) and PayPal payments">Payments</AdminTitle>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
        <div className="rounded-2xl bg-white border p-5"><p className="text-xs text-slate-500">Paid total</p><p className="font-display text-2xl font-extrabold" data-testid="admin-payments-total">{money(paid.reduce((a, p) => a + p.amount, 0))}</p></div>
        <div className="rounded-2xl bg-white border p-5"><p className="text-xs text-slate-500">Paid orders</p><p className="font-display text-2xl font-extrabold">{paid.length}</p></div>
      </div>
      {list && !list.length && <p className="text-sm text-slate-500" data-testid="admin-payments-empty">No payments yet.</p>}
      <div className="space-y-2.5">
        {(list || []).map((p) => (
          <div key={p.id} className="rounded-2xl bg-white border p-4 grid sm:grid-cols-[1fr_auto] gap-2" data-testid={`admin-payment-${p.id}`}>
            <div className="min-w-0">
              <p className="font-semibold truncate">{p.name} <span className="text-slate-400 font-normal text-sm">· {p.email}</span></p>
              <p className="text-sm text-slate-600">{p.package_name}</p>
              <p className="text-xs text-slate-400 mt-0.5">{new Date(p.created_at).toLocaleString()} · {p.provider === "paypal" ? "PayPal" : "Card (Stripe)"}</p>
            </div>
            <div className="flex sm:flex-col items-center sm:items-end gap-2">
              <p className="font-display font-bold">{money(p.amount)}</p>
              <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold capitalize ${badge(p.payment_status)}`}>{p.payment_status}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
